<template>
    <section class="apartment-plan-main-content">
        <div class="container">
            <div class="apartment-plan-main-content--inner">
                <div class="apartment-plan__img-box">
                    <button type="button" @click.stop.prevent="store.commit('OPEN_MODAL', {name: 'zoomModal', selectedImage: 'images/apartments/main-img.png'} )">
                        <img src="images/apartments/main-img.png" alt="apartment-plan" class="apartment-plan-img">
                    </button>
                </div>
                <div class="apartment-plan__filter-box">
                    <div class="floor-select-box">
                        <p class="title">Change floor</p>
                        <ul class="select-list">
                            <li class="select-list__item"><button type="button" class="select-list__btn active">1</button></li>
                            <li class="select-list__item"><button type="button" class="select-list__btn">2</button></li>
                            <li class="select-list__item"><button type="button" class="select-list__btn">3</button></li>
                            <li class="select-list__item"><button type="button" class="select-list__btn">4</button></li>
                            <li class="select-list__item"><button type="button" class="select-list__btn">5</button></li>
                        </ul>
                    </div>
                    <div class="rooms-info-table-box">
                        <VTable
                            class="rooms-info-table"
                            :data="apartments"
                        >
                            <template #head>
                                <th>Rooms</th>
                                <th class="area-cell">m <sup>2</sup></th>
                                <th class="condition-cell">Condition</th>
                            </template>
                            <template #body="{ rows }">
                                <tr v-for="row in rows" :key="row.id" :class="row.id === 3 ? 'selected' : ''">
                                    <td class="text-primary">{{ row.rooms }}</td>
                                    <td class="area-cell">{{ row.area }}m <sup>2</sup></td>
                                    <td class="condition-cell" :class="row.condition === 'sold out' ? 'sold-out' : '' ">
                                        {{ row.condition }}
                                    </td>
                                </tr>
                            </template>
                        </VTable>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import {ref} from "vue";
import { useStore } from 'vuex'
const store = ref(useStore())
const apartments = ref([])

apartments.value = [
    {
        id: 1,
        rooms: 2,
        area: 66,
        floor: 1,
        condition: 'sold out'
    },
    {
        id: 2,
        rooms: 3,
        area: 84,
        floor: 2,
        condition: 'available'
    },
    {
        id: 3,
        rooms: 2,
        area: 66,
        floor: 2,
        condition: 'available'
    },
    {
        id: 4,
        rooms: 3,
        area: 84,
        floor: 1,
        condition: 'sold out'
    },
    {
        id: 5,
        rooms: 3,
        area: 84,
        floor: 5,
        condition: 'available'
    },
    {
        id: 6,
        rooms: 2,
        area: 66,
        floor: 5,
        condition: 'available'
    },
    {
        id: 7,
        rooms: 3,
        area: 84,
        floor: 5,
        condition: 'available'
    },
]

</script>
